import React from 'react';
import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    ExpanderBorderStyle,
    Panel,
    PanelTheme,
    PanelBorderRadius,
    PanelBorderStyle,
    renderCustomCountExpanderHeader,
} from '@apply/components';
import { IDashboardApplicationItem } from '@apply/api/src/api/ApplyApi';
import { isMobileScreen } from '@apply/ui';
import '../scss/_homepanels.scss';

interface LoansApprovedToCloseParameters {
    applications: IDashboardApplicationItem[];
}

export const LoansApprovedToClosePanel: React.FC<LoansApprovedToCloseParameters> = ({ applications }) => {
    return (
        <div>
            <Expander
                header={renderCustomCountExpanderHeader(applications.length, 'Loans Approved to Close')}
                theme={ExpanderTheme.Red}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
            >
                {applications.map((app) => {
                    const addresses = app.properties.map((prop) => {
                        const { street1, street2, city } = prop;
                        return { street: [street1, street2].filter(Boolean).join(', '), city: city };
                    });

                    return (
                        <div
                            key={app.applicationId}
                            style={{ marginLeft: '20px', marginRight: '20px' }}
                        >
                            <Panel
                                key={app.properties.map((prop) => prop.id).join('-')}
                                padding={10}
                                theme={PanelTheme.White}
                                borderRadius={PanelBorderRadius.Small}
                                borderStyle={PanelBorderStyle.Solid}
                            >
                                <div className='panelContent loansApprovedToClose'>
                                    {addresses.map((address, i) => (
                                        <div
                                            key={i}
                                            className='address'
                                        >
                                            {isMobileScreen() ? (
                                                <>
                                                    <div className='addressItem'>{address.street}</div>
                                                    <div className='addressItem'>{address.city}</div>
                                                </>
                                            ) : (
                                                <div className='addressItem'>{`${address.street} ${address.city}`}</div>
                                            )}
                                        </div>
                                    ))}
                                    <div className='contact'>Contact BFI to close</div>
                                </div>
                            </Panel>
                        </div>
                    );
                })}
            </Expander>
        </div>
    );
};
